"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomError = exports.CustomErrorTypeEnum = void 0;
/* Error type enum declaration */
/**
 * In following enum errors with type 'Warning' will be shown in UI(frontend) so that user can see the errors
 * and fix it by updating inputs.
 * Errors with type 'Error' are calculations errors which will not be shown to the user but it can used for
 * different validations.
 */
var CustomErrorTypeEnum;
(function (CustomErrorTypeEnum) {
    CustomErrorTypeEnum["Error"] = "ERROR";
    CustomErrorTypeEnum["Warning"] = "WARNING";
})(CustomErrorTypeEnum || (exports.CustomErrorTypeEnum = CustomErrorTypeEnum = {}));
/**
 * The CustomError class is a TypeScript class that extends the Error class and allows for the creation
 * of custom error objects with an optional type property.
 */
class CustomError extends Error {
    constructor(message, type) {
        super(message);
        if (type) {
            this.type = type;
        }
        else {
            this.type = CustomErrorTypeEnum.Error;
        }
        /**
         * This is added so that if in front end we need to check 'instanceOf' this class it should work.
         * Without setPrototypeOf 'instanceof' checks might not work as expected, potentially causing issues.
         */
        Object.setPrototypeOf(this, CustomError.prototype);
    }
}
exports.CustomError = CustomError;
exports.default = CustomError;
//# sourceMappingURL=CustomError.js.map